import React from 'react'

export const stripAccents = (value = '') => {
	return String(value || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')
}

export const normalizeQueryText = (value = '') => {
	return stripAccents(String(value || '').trim()).toLowerCase()
}

export const getSearchConversationTitle = (conversationName = '') => {
	if (!conversationName) {
		return 'Conversa monitorada'
	}

	return String(conversationName).trim()
}

export const getSearchConversationName = (conversationName = '') => {
	if (!conversationName) {
		return 'Conversa monitorada'
	}

	const parts = conversationName.split(':')
	if (parts.length > 1) {
		return parts.slice(1).join(':').trim() || conversationName
	}

	return conversationName
}

export const getSearchMessageSender = (message) => {
	if (!message) return 'Contato'
	return message?.pushName || message?.sender || (message?.fromMe ? 'Você' : 'Contato')
}

export const getSearchResultSubtitle = (result) => {
	if (!result) {
		return ''
	}

	const senderName = getSearchMessageSender(result?.messages?.[0])
	const conversationName = getSearchConversationTitle(result?.conversationName || '')
	const accountName = result?.account?.name || ''

	if (!senderName || !conversationName) {
		return ''
	}

	const normalizedSender = normalizeQueryText(senderName)
	const normalizedConversation = normalizeQueryText(conversationName)
	const normalizedAccount = normalizeQueryText(accountName)

	if (
		normalizedSender === normalizedConversation ||
		normalizedSender === normalizedAccount ||
		(normalizedAccount && normalizedConversation.includes(normalizedAccount))
	) {
		return ''
	}

	return senderName
}

export const highlightQuery = (text = '', query = '') => {
	if (!query || !text) {
		return text
	}

	const normalizedQuery = normalizeQueryText(query)
	if (!normalizedQuery) {
		return text
	}

	const chars = Array.from(text)
	const normalizedChars = chars.map((char) => stripAccents(char).toLowerCase())
	const normalizedText = normalizedChars.join('')

	const parts = []
	let lastOriginalIndex = 0
	let searchPos = 0

	while (true) {
		const matchPos = normalizedText.indexOf(normalizedQuery, searchPos)
		if (matchPos === -1) {
			break
		}

		let originalStart = 0
		let normalizedPosition = 0
		for (let i = 0; i < chars.length; i += 1) {
			const nd = normalizedChars[i]
			if (normalizedPosition >= matchPos) {
				originalStart = i
				break
			}
			normalizedPosition += nd.length
		}

		let originalEnd = originalStart
		normalizedPosition = matchPos
		while (originalEnd < chars.length && normalizedPosition < matchPos + normalizedQuery.length) {
			normalizedPosition += normalizedChars[originalEnd].length
			originalEnd += 1
		}

		if (lastOriginalIndex < originalStart) {
			parts.push(text.slice(lastOriginalIndex, originalStart))
		}

		parts.push(
			<strong key={`highlight-${matchPos}`} className="scout-search-highlight">
				{text.slice(originalStart, originalEnd)}
			</strong>
		)

		lastOriginalIndex = originalEnd
		searchPos = matchPos + normalizedQuery.length
	}

	if (lastOriginalIndex < text.length) {
		parts.push(text.slice(lastOriginalIndex))
	}

	if (parts.length === 0) {
		return text
	}

	return <>{parts}</>
}
